<template>
    
    <div>
        
            <div class="appd">
  <div class="ind-title lh50 f16">
      <!-- <i class="el-icon-loading"></i> -->
      回收站拒收统计
    </div>

    <!-- <div class="ind-title lh50 f16"  @click="gethqjugengduo">
      更多
    </div> -->
    
</div>

    <div class="wod">
      <div v-for="(item, i) in refList" :key="i" class="wopdfff">
        <div class="jei">
          <div><img class="jei-img" :src="item.bandImg" alt="" /></div>

          <div style="margin: auto">
            <div class="au1 yhx1">{{ item.refCount }}</div>
            <div class="au1">拒收个数</div>
          </div>
        </div>
      </div>
    </div>





    </div>
</template>


<script>
export default {

  data() {
    return {
      add: [],
      addORUpdateVisible1: false,
      stockTotal: "",
      refCount: "",
      roadCount: "",
      houseCount: "",
      oldAdd: "",
      nowStockList: [],
      refList: [],
      content: "",
    };
  },



created() {
    this.getindexlist();


  },



  methods:{
       
        getindexlist() {
      this.$api.activitymsg.getOpHomePage({}).then((e) => {
        this.refList = e.data.refList;

        this.nowStockList = e.data.nowStockList;
        this.oldAdd = e.data.oldAdd;

        this.stockTotal = e.data.stockTotal;

        this.refCount = e.data.refCount;
        this.roadCount = e.data.roadCount;

        this.houseCount = e.data;
        console.log(e.data.oldAdd.oldAddRoadStock);
      });
    },



  },















    
}
</script>

<style scoped>


.wopdfff{
    width: 25%;
   margin-top: 20px;
}

.appd{
    display: flex;
  justify-content: space-between;
  align-content: center;
}


.yhxa {
  height: 50px;
}

.yhx5 {
  margin-left: 15px;
  font-family: SourceHanSansSC;
  font-weight: 400;
  font-size: 13px;
  color: rgb(16, 16, 16);
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.yhx3-a {
  display: flex;
  align-items: center;
  width: 90%;
  margin: auto;
  height: 28px;
}

.yhx9 {
  width: 10px;
  height: 10px;
  background: #e55757;
  border-radius: 50%;
  opacity: 1;
}

.yhx3 {
  font-family: SourceHanSansSC;
  font-weight: 400;
  font-size: 13px;
  color: rgb(255, 152, 0);
  margin-right: 10px;
}

.yhx2 {
  display: flex;
  align-items: center;
  /* justify-content: center; */
}

.yhx1 {
  font-family: FZLanTingHei;
  font-weight: 400;
  font-size: 22px;
}

.au1 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tt2 {
  font-family: SourceHanSansSC;
  font-weight: 400;
  font-size: 13px;
}

.tt1-a {
  margin-left: 10px;
  font-family: SourceHanSansSC;
  font-weight: 400;
  font-size: 28px;
  color: rgb(0, 0, 0);
}

.tt1-txt {
  font-family: SourceHanSansSC;
  font-weight: 400;
  font-size: 28px;
  color: rgb(255, 140, 0);
}

.tt1 {
  display: flex;

  align-items: center;
}

.ad1 {
  color: orangered;
}
.w2 {
  width: 100%;
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
}
.w1 {
  width: 90%;
  height: 40px;
  margin: auto;
  border-bottom: 1px solid var(--table-border);
  display: flex;
  justify-content: space-between;
}
.laobo {
  width: 300px;
  /* height: 191px; */
  border: var(--table-border) solid 1px;
}

.wod {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
}
.add1 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.jei-img {
  /* width: 100px; */
  height: 50px;
}

.jei {
  width: 260px;
  height: 80px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: solid 1px var(--table-border);
}
.c3 {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}

.c2 {
  width: 800px;
  border: solid 1px var(--table-border);
}

.c1 {
  display: flex;
  justify-content: space-between;
  width: 95%;
  margin: auto;
}

.t1 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}

.a6 {
  flex: 1;
  border: solid 1px var(--table-border);
}

.a5 {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.a4 {
  width: 400px;
  height: 191px;
  margin-left: 20px;
  border: solid 1px var(--table-border);

  cursor: pointer;
}
.a3 {
  width: 95%;
  margin: auto;
  display: flex;
  justify-content: space-between;
}

.a1 {
  background: rgb(246, 246, 247);
  border: solid 1px var(--table-border);
}

.a {
  width: 95%;
  margin: auto;
  height: 50px;
  display: flex;
  align-items: center;
}

.a-bcd {
  width: 95%;
  margin: auto;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

</style>